import React, { Fragment, useState, useEffect } from "react";
import useLicenses from "../../lib/useFetchOtherLicenses";
import { useDeleteOtherLicenses } from "../../lib/useDeleteOtherLicenses";
import { CiFileOn } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import { ReactComponent as Markicon } from "../../../Asset/circle.svg";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "./view.css";

const ViewOtherLicenses = () => {
  const { data, error, isLoading } = useLicenses();
  const deleteMutation = useDeleteOtherLicenses();

  const [isDeleteOverlayVisible, setDeleteOverlayVisible] = useState(false);
  const [selectedFileToDelete, setSelectedFileToDelete] = useState(null);
  const [isDeleted, setIsDeleted] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);

  const toggleDeleteOverlay = () => {
    setDeleteOverlayVisible(!isDeleteOverlayVisible);
  };

  const handleFileSelection = (file) => {
    setSelectedFileToDelete(file);
    toggleDeleteOverlay();
  };

  const handleDelete = () => {
    if (selectedFileToDelete) {
      const fileToDelete = {
        otherLicenses: [
          {
            name: selectedFileToDelete.name,
            fileUrl: selectedFileToDelete.fileUrl,
          },
        ],
      };
      setIsDeleting(true);
      deleteMutation.mutate(fileToDelete, {
        onSuccess: () => {
          console.log("File deleted successfully!");
          setIsDeleted(true);
          setSelectedFileToDelete(null);
          toggleDeleteOverlay();
        },
        onError: (error) => {
          console.error("Error deleting file:", error);
          setDeleteError(
            error.response?.data?.message ||
              "An error occurred while deleting the file."
          );
        },
        onSettled: () => {
          setIsDeleting(false);
        },
      });
    }
  };

  const handleViewPdf = (url) => {
    setIsLoadingPdf(true);
    setPdfUrl(url);
    setShowModal(true);
  };

  useEffect(() => {
    if (pdfUrl) {
      const timer = setTimeout(() => setIsLoadingPdf(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [pdfUrl]);

  const closeModal = () => {
    setShowModal(false);
    setPdfUrl("");
  };

  if (isLoading) {
    return (
      <div className="sta-card">
        {[...Array(3)].map((_, index) => (
          <div className="cards" key={index}>
            <div className="in">
              <Skeleton circle height={40} width={40} />
              <div className="size">
                <Skeleton height={20} width={100} />
                <Skeleton height={16} width={200} />
              </div>
            </div>
            <div className="mark">
              <Skeleton height={30} width={60} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (error) return <div>Error: {error.message}</div>;

  const licenses = data.data?.licenses || [];

  return (
    <Fragment>
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {isLoadingPdf ? (
              <p>Loading document...</p>
            ) : (
              <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
                <Viewer fileUrl={pdfUrl} />
              </Worker>
            )}
          </div>
          <button className="close-btn" onClick={closeModal}>
            Close
          </button>
        </div>
      )}

      {isDeleteOverlayVisible && (
        <div className="delete-overlay">
          <div className="delete-overlay-content">
            <h2>Delete Confirmation</h2>
            <p>Are you sure you want to delete this file?</p>
            <div className="btn-group">
              <button onClick={toggleDeleteOverlay}>No</button>
              <button onClick={handleDelete} disabled={isDeleting}>
                {isDeleting ? "Deleting..." : "Yes"}
              </button>
            </div>
            {deleteError && <p>Error: {deleteError}</p>}
          </div>
        </div>
      )}

      <div className="sta">
        {licenses && (
          <div className="sta-card">
            {licenses.dpr && (
              <div className="cards">
                <div className="in">
                  <CiFileOn className="file" />
                  <div className="size">
                    <h4>dpr</h4>
                    <p>200 KB – 100% Uploaded</p>
                  </div>
                </div>
                <div className="mark">
                  <Markicon />
                  <button onClick={() => handleViewPdf(licenses.dpr)}>View</button>
                </div>
              </div>
            )}

            {licenses.others && licenses.others.length > 0 ? (
              licenses.others.map((license) => (
                <div className="cards" key={license._id}>
                  <div className="in">
                    <CiFileOn className="file" />
                    <div className="size">
                      <h4>{license.name}</h4>
                      <p>200 KB – 100% Uploaded</p>
                    </div>
                  </div>
                  <div className="mark">
                    <button onClick={() => handleFileSelection(license)}>
                      <RiDeleteBin6Line />
                    </button>
                    <button onClick={() => handleViewPdf(license.fileUrl)}>View</button>
                  </div>
                </div>
              ))
            ) : (
              <p style={{fontFamily:"Montserrat", fontSize:"16px", fontWeight:"500", color:"#000000"}}>No other licenses available.</p>
            )}
          </div>
        )}

        {isDeleted && <p>File deleted successfully!</p>}
      </div>
    </Fragment>
  );
};

export default ViewOtherLicenses;
